import { useState, useEffect } from 'react';
import { _PayrollFactor } from '../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { Modal } from '../../../theme/Component/Modal';
import { ValueTypeSelector } from '../ImportedPayrollConcept/EditorsySelectors/ValueType.Selector';
import { FortnightTypeConstants } from '../PayrollFactor/FortnightTypeConstants';
import { BasicButton } from '../../../theme/Component/BasicButton';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
    typeFortnight?: number;
}

export const PayrollFactorVdosSelect = ({ idSelector, onChange, label, returnType = "ID", render, typeFortnight }: Props) => {

    const { instance, lista, setLista } = useDataBean(_PayrollFactor)
    const [id, setID] = useState(null);
    const [valueclass, setValueclass] = useState<number>(null)
    const [fornight, setFornight] = useState<number>(null)
    const modal = useModal("", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])
    useEffect(() => {
        if (typeFortnight)
            setValueclass(typeFortnight);
    }, [typeFortnight])
    useEffect(() => {
        if (valueclass) {
            getLista();
        }
    }, [valueclass])

    // useEffect(() => {
    //     getLista();
    // }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDPayrollFactor == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);                
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getPayrollFactorCatalog(valueclass, fornight).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);

                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDPayrollFactor', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Código', property: 'Code', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Factores de Nómina"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    {!typeFortnight &&
                        <>
                            <div className="col-md-4">
                                <ValueTypeSelector label="Clase Factor" idSelector={valueclass} onChange={(e) => { setValueclass(e) }} />
                            </div>
                            <div className="col-md-4">
                                <FortnightTypeConstants idSelector={fornight} onChange={(e) => { setFornight(e) }} />
                            </div>
                            <div className="col-md-4 mt-4 p-2">

                                <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                            </div>
                        </>
                    }
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDPayrollFactor); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}